// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/controllers/admin/settings/departments/style.less
// module id = 927
// module chunks = 0